import { Package, Clock, Tag, Award } from "lucide-react";
import useCountUp, { useInView } from "../../hooks/useCountUp";

const STATS = [
  { icon: Package, target: 500, suffix: "+", label: "Ekipman Çeşidi" },
  { icon: Clock, target: 24, suffix: " Saatte", label: "Özelleştirilmiş Teklif" },
  { icon: Tag, target: 100, suffix: "%", label: "Özel Marka Üretim" },
  { icon: Award, target: 15, suffix: "+ Yıl", label: "Sektör Deneyimi" },
];

function StatCard({ icon: Icon, target, suffix, label, trigger }) {
  const val = useCountUp(target, 1600, trigger);
  return (
    <div className="text-center px-4" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <div className="h-12 w-12 mx-auto rounded-full bg-teal/10 text-teal flex items-center justify-center mb-3">
        <Icon size={22} />
      </div>
      <div className="heading-serif text-4xl font-bold text-navy">
        {val}
        <span className="text-gold">{suffix}</span>
      </div>
      <div className="text-sm text-gray-500 mt-1 tracking-wide">{label}</div>
    </div>
  );
}

export default function StatsPanel() {
  const [ref, inView] = useInView(0.25);
  return (
    <section ref={ref} className="bg-white -mt-14 relative z-20 container-site" data-testid="stats-panel">
      <div className="card-premium !shadow-[0_10px_40px_rgba(8,17,29,0.08)] grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-gray-100 py-8 md:py-10">
        {STATS.map((s) => (
          <StatCard key={s.label} {...s} trigger={inView} />
        ))}
      </div>
    </section>
  );
}
